import React, { useState, useCallback, useEffect } from 'react';
import PieChart, {
  Legend as PCLegend,
  Series as PCSeries,
  Tooltip as PCTooltip,
  Label,
} from 'devextreme-react/pie-chart';
import { groupBy } from '../../utils/miscUtil';
import { TagBox } from 'devextreme-react/tag-box';

export default function ESGGoals(props) {
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [selectedCompaniesList, setSelectedCompaniesList] = useState([]);
  const [climate1Data, setClimate1Data] = useState([]);
  const [climate2Data, setClimate2Data] = useState([]);
  const [climate3Data, setClimate3Data] = useState([]);
  const [climate4Data, setClimate4Data] = useState([]);
  const [climate5Data, setClimate5Data] = useState([]);
  const [climate6Data, setClimate6Data] = useState([]);
  const [climate7Data, setClimate7Data] = useState([]);
  const [climate8Data, setClimate8Data] = useState([]);
  const [climate9Data, setClimate9Data] = useState([]);
  const [climate10Data, setClimate10Data] = useState([]);
  const [climate11Data, setClimate11Data] = useState([]);
  const [climate12Data, setClimate12Data] = useState([]);
  const [climate13Data, setClimate13Data] = useState([]);
  const [climate14Data, setClimate14Data] = useState([]);

  useEffect(() => {
    var fd = [];
    var fd1 = [];
    var i=0;

    fd1 = groupBy(props.data, 'company_name')
    setAllCompaniesList(Object.keys(fd1).sort())

    var originalData = props.data
    if (selectedCompaniesList.length) {
      originalData = originalData.filter((it) => selectedCompaniesList.includes(it['company_name']));
    }

    fd = originalData.filter((e) => {return e["Identifier"]==="119" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate1Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="126" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate2Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="132" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate3Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="148" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate4Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="146" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate5Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="144" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate6Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="164" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate7Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="202" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate8Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="152" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate9Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="154" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate10Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="156" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate11Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="158" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate12Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="160" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate13Data(fd);

    fd = originalData.filter((e) => {return e["Identifier"]==="162" && e["year"] ===(parseInt(props.year)-1).toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "N"
      } else {
        fd[i]["value"] = fd[i]["value"].trim().toUpperCase();
      }
    }
    fd = groupBy(fd,"value");
    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length, companies: fd[key].map((it) => it['company_name'])}));
    setClimate14Data(fd);

  }, [props.data, props.year, selectedCompaniesList]);

  const onCompaniesChanged = useCallback((e) => {
    setSelectedCompaniesList(e.value);
  }, [setSelectedCompaniesList])

  const customizeTooltip = useCallback((pointInfo) => {
    var txt = ''
    txt = `<div><div class="tooltip-header">${pointInfo.argumentText}: ${pointInfo.valueText}</div><div class="tooltip-body">${pointInfo.point.data.companies.join(", ")}</div></div>`
    return {
      html: txt,
    }
  }, []);

  function customizePoint(point) {
    let fillId;
    switch (point.argument) {
      case 'Y':
        fillId = "rgba(20, 77, 109, 1)";
        break;
      case 'N':
        fillId = "rgba(236, 80, 32, 1)";
        break;
      case 'NR':
        fillId = "rgba(0, 0, 0, 0.3)";
        break;
      default:
        break;
    }
    return { color: { fillId } };
  }

  return (
    <>
    <h4>Goals and Targets in {parseInt(props.year)-1} </h4>
    <div className="d-flex flex-row">
      <TagBox
          dataSource={allCompaniesList}
          value={selectedCompaniesList}
          showDropDownButton={true}
          width="100%"
          activeStateEnabled={true}
          multiline={false}
          showSelectionControls={true}
          onValueChanged={onCompaniesChanged}
          label={"Company"}
          labelMode="floating"
          placeholder={"Select Companies"}
      />
    </div>
    <hr className={'mb-4'}/>
    <div className="d-flex flex-column justify-content-between">
      <h5>Companies with Climate Goals</h5>
      <div className="d-flex flex-row w-100 justify-content-between">
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Companies with a Net Zero Target"}
            dataSource={climate1Data}
            resolveLabelOverlapping={"shift"}
            customizePoint={customizePoint}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1} horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Companies with an Emission Reduction Target"}
            customizePoint={customizePoint}
            dataSource={climate2Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1}   horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Companies with Multiple Emission Reduction Targets"}
            customizePoint={customizePoint}
            dataSource={climate3Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1}   horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
      </div>
      <hr className={'mb-4'}/>
      <h5>Companies with Flaring Goals</h5>
      <div className="d-flex flex-row w-100 justify-content-between">
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Companies with a Flaring Reduction Target"}
            customizePoint={customizePoint}
            dataSource={climate4Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1}   horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Companies Committed to Ending Routing Flaring"}
            customizePoint={customizePoint}
            dataSource={climate5Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1}   horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Companies Aligned with World Bank Routing Flaring Initiative"}
            customizePoint={customizePoint}
            dataSource={climate6Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1}   horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
      </div>
      <hr className={'mb-4'}/>
      <div className="d-flex flex-row w-100 justify-content-between">
        <div className="d-flex flex-column justify-content-between" style={{width:"49%"}}>
          <h5>Companies who Tie Compensation to ESG Goals and Targets</h5>
          <PieChart
            id="pie"
            type="doughnut"
            customizePoint={customizePoint}
            dataSource={climate7Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1}   horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"49%"}}>
          <h5>Companies Disclosing ESG Committed Capital</h5>
          <PieChart
            id="pie"
            type="doughnut"
            customizePoint={customizePoint}
            dataSource={climate8Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1}   horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
      </div>
      <hr className={'mb-4'}/>
      <h5>All Other Performace Goals</h5>
      <div className="d-flex flex-row w-100 justify-content-between">
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Spill Reduction Target"}
            customizePoint={customizePoint}
            dataSource={climate9Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1}   horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Water Reduction Target"}
            customizePoint={customizePoint}
            dataSource={climate10Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1}   horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Biodiversity Target"}
            customizePoint={customizePoint}
            dataSource={climate11Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1}   horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
      </div>
      <div className="d-flex flex-row w-100 justify-content-between">
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Waste Reduction Target"}
            customizePoint={customizePoint}
            dataSource={climate12Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1}   horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Safety Target"}
            customizePoint={customizePoint}
            dataSource={climate13Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1}   horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
        <div className="d-flex flex-column justify-content-between" style={{width:"32%"}}>
          <PieChart
            id="pie"
            type="doughnut"
            title={"Social Target"}
            customizePoint={customizePoint}
            dataSource={climate14Data}
            resolveLabelOverlapping={"shift"}
          >
            <PCSeries argumentField="name">
              <Label visible={true} position="inside" backgroundColor="transparent"/>
            </PCSeries>
            <PCLegend rowCount={1}   horizontalAlignment="center" verticalAlignment="bottom" />
            <PCTooltip enabled={true} customizeTooltip={customizeTooltip}>
            </PCTooltip>
          </PieChart>
        </div>
      </div>
    </div>
    </>
  );
}
